import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { Trans } from "react-i18next";

import Link from "../Link";

const ArticleHeader = ({ title, date, topic, categories }) => {
  const data = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "images/icons/zipmex-icon.svg" }) {
        publicURL
      }
    }
  `);

  const CategoryLinks = () => {
    const linkTo = topic === "glossary" ? "/" : "/learn/filtration/?topic=";
    return [...categories].map((cat, i) => (
      <div
        key={`article-header-category-${i}`}
        className="article-header__detail-categories d-inline"
      >
        <Link to={`${linkTo}${topic}${i > 0 ? `&cat=${cat}` : ""}`}>
          {cat?.replace(/-/g, " ")}
        </Link>
        {i < categories.size - 1 && ", "}
      </div>
    ));
  };

  return (
    <div className="article-header grid-container">
      <h1
        className="grid-col-12 grid-col-lg-10 grid-offset-lg-2 mb-4"
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <div className="grid-col-12 grid-col-lg-10 grid-offset-lg-2 d-flex align-items-center">
        <div>
          <img
            className="article-header__logo-image img-fluid "
            src={data.logo.publicURL}
            alt=""
            height={50}
            width={50}
          />
        </div>
        <span className="article-header__detail ml-4">
          <Trans i18nKey={"article.postedOn"}>
            Posted on {{ date: date }} in
          </Trans>
          <CategoryLinks />
        </span>
      </div>
    </div>
  );
};

export default ArticleHeader;
